export const getAddressComponents = () => ({
  code: '15865',
  name: 'RESIDENZA',
  bundleLink: null,
  bundleCode: null,
  components: [
    {
      name: 'CAP',
      value: '',
      rawValue: null,
      active: true,
      status: [],
      errorMessage: [],
      validations: ['cap', 'required'],
      values: [],
      type: null
    },
    {
      name: 'CITTA',
      value: '',
      rawValue: null,
      active: true,
      status: [],
      errorMessage: [],
      validations: ['required', 'city'],
      values: [],
      type: null
    },
    {
      name: 'INDIRIZZO',
      value: '',
      rawValue: null,
      active: true,
      status: [],
      errorMessage: [],
      validations: ['required'],
      values: [],
      type: null
    },
    {
      name: 'NAZIONE',
      value: '',
      rawValue: null,
      active: true,
      status: [],
      errorMessage: [],
      validations: ['word', 'required'],
      values: [],
      type: null
    },
    {
      name: 'PROVINCIA',
      value: '',
      rawValue: null,
      active: true,
      status: [],
      errorMessage: [],
      validations: ['word', 'required'],
      values: [],
      type: null
    }
  ],
  status: [],
  errorMessage: []
})
export const getPECAddressComponent = () => { 
  return {
    widgets:[ 
      {
        code:"19356",
        name: 'PEC',
        bundleLink: null,
        bundleCode: null,
        components:[
          {
            name: 'ADDRESS',
            value: 'L’indirizzo PEC è importante per la ricezione della comunicazione periodica',
            rawValue: null,
            status: [],
            errorMessage: [],
            validations: [],
            values: [],
            type: 'label',
            active:true
          }
        ]
      }
    ]
    
  }
}
export const getDocumentoRulesComponent = () => { 
  return {
    widgets:[ 
      {
        code:"15773",
        name: 'DOCUMENTO',
        bundleLink: null,
        bundleCode: null,
        components:[
          {
            name: 'DOCUMENTRULES',
            value: 'I formati accettati sono:PDF, JPEG, GIF, PNG, PJPEG, X-PNG.Il peso massimo consentito per documento è di 7MB. Per un documento PDF, il numero massimo di pagine consentito è 5.',
            rawValue: null,
            status: [],
            //position:7,
            errorMessage: [],
            validations: [],
            values: [],
            type: 'label',
            isSmall:true,
            active:true
          },
          {
            name: 'DOCUMENTRULES2',
            value: '<b>Il documento non deve avere scadenza nei prossimi 3 mesi</b>.<br/>I formati accettati sono:PDF, JPEG, GIF, PNG, PJPEG, X-PNG.Il peso massimo consentito per documento è di 7MB. Per un documento PDF, il numero massimo di pagine consentito è 5.',
            rawValue: null,
            status: [],
            //position:7,
            errorMessage: [],
            validations: [],
            values: [],
            type: 'label',
            isSmall:true,
            active:false
          }
        ]
      },
      {
        code:"15774",
        name: 'DOCUMENTO_2',
        bundleLink: null,
        bundleCode: null,
        components:[
          {
            name: 'SECONDDOCUMENTRULE1',
            value: '<b>Il documento deve essere intestato al richiedente e non più vecchio di 3 mesi</b>.<br/>I formati accettati sono:PDF, JPEG, GIF, PNG, PJPEG, X-PNG.Il peso massimo consentito per documento è di 7MB. Per un documento PDF, il numero massimo di pagine consentito è 5.',
            rawValue: null,
            status: [],
            position:13,
            errorMessage: [],
            validations: [],
            values: [],
            type: 'label',
            isSmall:true,
            active:false
          },
          {
            name: 'SECONDDOCUMENTRULE2',
            value: 'I formati accettati sono:PDF, JPEG, GIF, PNG, PJPEG, X-PNG.Il peso massimo consentito per documento è di 7MB. Per un documento PDF, il numero massimo di pagine consentito è 5.',
            rawValue: null,
            status: [],
            position:14,
            errorMessage: [],
            validations: [],
            values: [],
            type: 'label',
            isSmall:true,
            active:true
          },
          {
            name: 'SECONDDOCUMENTRULE3',
            value: '<b>Il documento non deve avere scadenza nei prossimi 3 mesi</b>.<br/>I formati accettati sono:PDF, JPEG, GIF, PNG, PJPEG, X-PNG.Il peso massimo consentito per documento è di 7MB. Per un documento PDF, il numero massimo di pagine consentito è 5.',
            rawValue: null,
            status: [],
            position:15,
            errorMessage: [],
            validations: [],
            values: [],
            type: 'label',
            isSmall:true,
            active:false
          }
        ]
      }
    ]
    
  }
}


// WEBPACK FOOTER //
// ./state/static/addressStatic.js